<script>
import {mdiImage, mdiImageAlbum} from "@mdi/js";

export default {
  name: 'Restaurant',
  data() {
    return {
      subTabs: [
        { title: 'Menus Resto', icon: mdiImage },
        { title: 'Nouveau Menu', icon: mdiImageAlbum },
      ],
      tab_content: null,
      galleryType: '',
      galleryAllType: [],
      selectedItem: 1,
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
    }
  },

}
</script>

<template>
  <div>
    <v-row>
      <v-col
          cols="12"
          md="12"
      >
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Liste des Menus du site web
            </span>
      </v-col>
    </v-row>
    <v-tabs
        v-model="tab_content"
        show-arrows
        style="margin-bottom:1rem;"
    >
      <v-tab
          href="#tab-0"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[0].icon }}
        </v-icon>
        <span>{{ subTabs[0].title }}</span>
      </v-tab>
      <v-tab
          href="#tab-1"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[1].icon }}
        </v-icon>
        <span>{{ subTabs[1].title }}</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab_content" style="padding: 0.98rem;">
      <v-tab-item :value="'tab-'+0">
        <v-row>
          <v-col cols="6">
            <v-card
                variant="outlined"
            >
              <v-img
                  height="250"
                  src="https://cdn.vuetifyjs.com/images/cards/cooking.png"
              ></v-img>
              <v-card-title>
                Vin
              </v-card-title>
              <v-card-subtitle>jjjjjjjjjjjjjjj</v-card-subtitle>
              <v-card-text>
                <v-list shaped>
                  <v-list-item-group
                      v-model="selectedItem"
                      color="primary"
                  >
                    <v-list-item
                        v-for="(item, i) in items"
                        :key="i"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-btn>Click me</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card
                variant="outlined"
            >
              <v-img
                  height="250"
                  src="https://cdn.vuetifyjs.com/images/cards/cooking.png"
              ></v-img>
              <v-card-title>
                Vin
              </v-card-title>
              <v-card-subtitle>jjjjjjjjjjjjjjj</v-card-subtitle>
              <v-card-text>
                <v-list shaped>
                  <v-list-item-group
                      v-model="selectedItem"
                      color="primary"
                  >
                    <v-list-item
                        v-for="(item, i) in items"
                        :key="i"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-btn>Click me</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item :value="'tab-'+1">
        uuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu
      </v-tab-item>
    </v-tabs-items>
  </div>

</template>

<style scoped>

</style>